import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

export class ApplePayStore extends BaseStore {
    getInitialState() {
        return super.getInitialState().merge({
            clientToken: null,
            loading: false,
            error: null,
            supported: false,
        });
    }

    handleTokenLoading() {
        this.setState(this.state.set('loading', true).set('error', null));
    }

    handleTokenLoaded({ token }) {
        this.setState(this.state.set('clientToken', token).set('loading', false).set('error', null));
    }

    handleTokenError({ error }) {
        this.setState(this.state.set('loading', false).set('error', error));
    }

    handlePaymentStarted() {
        this.setState(this.state.set('loading', true));
    }

    handlePaymentFinished() {
        this.setState(this.state.set('loading', false));
    }

    handleSupported() {
        this.setState(this.state.set('supported', true));
    }

    handleNotSupported() {
        this.setState(this.state.set('supported', false));
    }

    getClientToken() {
        return this.get('clientToken');
    }

    getLoading() {
        return this.get('loading');
    }

    getError() {
        return this.get('error');
    }

    getAvailable() {
        return this.get('supported') && this.get('error') === null;
    }

    getActionHandlers() {
        return {
            [ActionTypes.APPLE_PAY_CLIENT_TOKEN_LOADING]: this.handleTokenLoading,
            [ActionTypes.APPLE_PAY_CLIENT_TOKEN_LOADED]: this.handleTokenLoaded,
            [ActionTypes.APPLE_PAY_CLIENT_TOKEN_ERROR]: this.handleTokenError,
            [ActionTypes.APPLE_PAY_PAYMENT_STARTED]: this.handlePaymentStarted,
            [ActionTypes.APPLE_PAY_PAYMENT_FINISHED]: this.handlePaymentFinished,
            [ActionTypes.APPLE_PAY_SUPPORTED]: this.handleSupported,
            [ActionTypes.APPLE_PAY_NOT_SUPPORTED]: this.handleNotSupported,
            [ActionTypes.LOGGED_OUT]: this.resetState
        };
    }
}

const instance = new ApplePayStore();

export default instance;
